/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
